import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { GenericService } from './generic.service';
import { AuthService } from './auth.service';
import { CompanyService } from './company.service';
import { JobService } from './job.service';
import { JobMatchService } from './job-match.service';
import { AlertAndNotificationsService } from './alert-and-notifications.service';
import { RequisitionCardActionsModalService } from './requisition-card-actions-modal.service';
import { RequisitionActionModalService } from './requisition-action-modal.service';
import { RequisitionBackwardActionModalService } from './requisition-backward-action-modal.service';
import { RequisitionActivityModalService } from './requisition-activity-modal.service';
import { JobSalary } from 'src/app/public/app/models/jobSalary';
import { FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from 'src/app/core/models/formalizePayload';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import moment from 'moment';
import * as _ from 'lodash';

declare var bootbox: any;

@Injectable({
  providedIn: 'root'
})
export class RequisitionService {

  urlConstants:any = {
    GET_ALL_SOURCE_TYPES: 'api/resume/resumesourcetypes',
    GET_VENDOR_RECRUITERS: 'api/user/vendor/recruiters',
    ASSIGN_VENDOR_RECRUITERS: 'api/job/assign/vendor/recruiters',
    GET_ASSIGNED_VENDOR_RECRUITERS: 'api/user/sharedrequisition/vendor/recruiters',
    UPLOAD_REQUISITION: 'api/requisition/uploadrequisitiondoc',
    GET_ALL_CLIENT_OR_BU: 'api/requisition/getclientorbulist',
    GET_REQUISITION_ACTIVITY: 'api/requisition/requisitionActivity',
    JOB_BOARD_ADVANCED_SEARCH: 'http://jbws-az-4dot5.daxtra.com/jwb/dispatch',
    GET_REQUISITION_DOCUMENT: 'api/requisition/getrequisitionfile',
    UPDATE_JOB_STATUS: 'api/job/status'

  };

  reasonCodes: any;

  constructor(
    private StorageService: StorageService,
    private genericService: GenericService,
    private authService: AuthService,
    private companyService: CompanyService,
    private jobService: JobService,
    private jobMatchService: JobMatchService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private requisitionCardActionsModalService: RequisitionCardActionsModalService,
    private requisitionActionModalService: RequisitionActionModalService,
    private requisitionBackwardActionModalService: RequisitionBackwardActionModalService,
    private requisitionActivityModalService: RequisitionActivityModalService
  ) { }

  getUploadUrl() {
    return this.StorageService.get('baseurl') + this.urlConstants.UPLOAD_REQUISITION;
  }

  getAllClientsOrBu(userDetails, requisitionId, isFromCreateReq, successCallback, errorCallback) {
    let url = this.StorageService.get('baseurl') + this.urlConstants.GET_ALL_CLIENT_OR_BU + '/' + userDetails.id + '/' + userDetails.company.companyId;
    if (!_.isNull(requisitionId)) {
        url = url + '?requisitionId=' + requisitionId;
        if (isFromCreateReq) {
            url = url + '&isFromCreateReq=true';
        }
    } else if (isFromCreateReq) {
        url = url + '?isFromCreateReq=true';
    }
    this.genericService.getObjects(url).subscribe((data: any) => {
        successCallback(data.body);
    }, (error: any) => {
        errorCallback(error);
    });
  }

  getRequisitionActivity(jobId, page, size, successCallback, errorCallback) {
        if(_.isNull(page) || _.isUndefined(page)) {
            page = 1;
        }
        if(_.isNull(size) || _.isUndefined(size)) {
            size = 10;
        }
        let url = this.StorageService.get('baseurl') + this.urlConstants.GET_REQUISITION_ACTIVITY + '/' + jobId + '?page=' + page + '&size=' + size + '&companyId=' + this.authService.getUserDetails().company.companyId;
        this.genericService.addObject(url, {}).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error.error);
        });
    }

    getJobBoardsAdvancedSearchInterface(searchObject, successCallback, errorCallback) {
        searchObject = {
            action: "search_interface",
            db: "jw_fourdotfive",
            codes: "IND",
            js_lib: "jquery",
            ajax_updater: "/jb/advancedsearch/updater",
            ajax_auto_completer: "/jb/advancedsearch/autoCompleter",
            libs: "jquery,jquery-ui,jb_params_jq,css"
        };

        this.genericService.addObject(this.urlConstants.JOB_BOARD_ADVANCED_SEARCH, searchObject).subscribe((data: any) => {
            successCallback(data.body);
        }, (error: any) => {
            errorCallback(error);
        });
    }

    getRequisitionDocumentUrl(requisitionId) {
        return this.StorageService.get('baseurl') + this.urlConstants.GET_REQUISITION_DOCUMENT + '/' + requisitionId;
    }

    getVendorRecruiters(vendorId, requisitionId, successCallback, errorCallback) {
        let searchObject:any = {};
        searchObject.vendorId = vendorId;
        searchObject.requisitionId = requisitionId;
        this.genericService.addObject(this.urlConstants.GET_VENDOR_RECRUITERS, searchObject).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }

    assignRecruiters(assignRecruitersObject, successCallback, errorCallback) {
        this.genericService.addObject(this.urlConstants.ASSIGN_VENDOR_RECRUITERS, assignRecruitersObject).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }

    getAssignedVendorRecruiters(requisitionId, vendorId, successCallback, errorCallback) {
        this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_ASSIGNED_VENDOR_RECRUITERS + '/' + requisitionId + '/' + vendorId).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }

    //common methods for requisition
    massageRequisitionCardInfo(data: any, salaryDurationOptions: any) {
        const response: any = {
            recruitersCount: 0
        };
        if (!data.recruiters) {
            data.recruiters = [];
        }
        if (!data.corporateRecruiters) {
            data.corporateRecruiters = [];
        }
        if (!data.vendorRecruiters) {
            data.vendorRecruiters = [];
        }
        const vendorRecruitersTemp: any[] = [];
        data.vendorRecruiters.forEach((recruiter: any) => {
            vendorRecruitersTemp.push({
                name: recruiter,
                isPoc: false,
                isVendor: true
            });
        });
        if (this.companyService.isCorporateCompany()) {
            data.recruiters = _.cloneDeep(data.corporateRecruiters);
        } else {
            data.recruiters = _.cloneDeep(vendorRecruitersTemp);
        }
        response.recruitersCount = data.recruiters.length > 0 ? data.recruiters.length - 1 : null;
        data.allRecruitersList = [...data.recruiters];
        //poc recruiter
        if (data.recruiters.length > 0) {
            response.pocRecruiter = data.recruiters.filter((recruiter: any) => recruiter.isPoc == true)[0];

            if (response.pocRecruiter == undefined) {
                response.pocRecruiter = data.recruiters[0];
            }
            _.remove(data.recruiters, { name: response.pocRecruiter.name });
        }

        data.hiringManagerDetails = data.corporateHiringManagers ? _.cloneDeep(data.corporateHiringManagers) : null;
        if (!_.isNull(data.hiringManagerDetails)) {
            if (data.hiringManagerDetails.length > 0) {
                response.primaryHiringManager = data.hiringManagerDetails.filter((manager: any) => manager.isPrimary == true)[0];
            }
        }

        if (_.isNull(data.jobSalaryDto)) {
            data.jobSalaryDto = new JobSalary();
        }
        data.salaryLabel = "Salary Details";
        if (data.jobType == 'Contractor' || data.jobType == 'Contract to Hire') {
            data.salaryLabel = this.companyService.isCorporateCompany() || data.sharedRequisition ? "Bill Rate" : "Client/Bill Rate";
        }
        data.requisitionSalaryDisplayMessage = this._getSalaryDetailsDisplayMessage(data.jobSalaryDto, salaryDurationOptions);
        if (_.isNull(data.sponsorshipProvided) || _.isUndefined(data.sponsorshipProvided)) {
            data.sponsorshipsDisplayMessage = "Sponsorship information not specified";
        } else if (_.isNull(data.sponsorships) || data.sponsorships.length == 0) {
            data.sponsorshipsDisplayMessage = "Not Available";
        } else if (data.sponsorships.length > 0) {
            let message = "";
            data.sponsorships.forEach((sponsor: any, key: number) => {
                if (key == data.sponsorships.length - 1) {
                    message = message + sponsor;
                } else if (key == data.sponsorships.length - 2) {
                    message = message + sponsor + " and ";
                } else {
                    message = message + sponsor + ", ";
                }
            });
            data.sponsorshipsDisplayMessage = message;
        }
        data.locationLabel = null;
        data.companyLabel = null;
        data.companyLocationLabel = null;
        if (this.companyService.isCorporateCompany()) {
            // if it is a corporate company
            if (!data.sharedRequisition && !_.isNull(data.clientName)) {
                // show BU name, if it exists
                data.companyLabel = data.clientName;
            } else if (data.sharedRequisition && !_.isNull(data.corporateBU)) {
                // show BU name, if it exists
                data.companyLabel = data.corporateBU;
            }
        } else {
            // if it is staffing/vendor company
            if (data.sharedRequisition || data.hasSharedCorporateOrBUClient) {
                // if it is shared requisition, show the corporation's name
                data.companyLabel = data.corporateName;
            } else {
                // it is not a shared requisition, show the client's name
                data.companyLabel = data.clientName;
            }
        }
        data.companyLocationLabel = _.isNull(data.companyLabel) ? '' : data.companyLabel;
        if (!_.isNull(data.location)) {
            if (!_.isNull(data.location.city) && !_.isNull(data.location.city.name)) {
                data.locationLabel = data.location.city.name;
            }
            if (!_.isNull(data.location.state)) {
                data.locationLabel = _.isNull(data.locationLabel) ? data.location.state : data.locationLabel + ', ' + data.location.state;
            }
        }
        data.companyLocationLabel = _.isNull(data.locationLabel) ? data.companyLocationLabel : data.companyLocationLabel + ' @ ' + data.locationLabel;
        if (!_.isNull(data.sharedClientBuName)) {
            data.companyLocationLabel = data.sharedClientBuName + " @" + data.companyLocationLabel;
        }
        if (data.workflowSteps) {
            this._removeReleasedAndUnInterestedSteps(data.workflowSteps);
        }
        data.noOfOpenings = data.requisitionOpeningsCount ? data.requisitionOpeningsCount.noOfOpenings : null;
        data.noOfFilled = data.requisitionOpeningsCount ? data.requisitionOpeningsCount.noOfFilled : null;
        data.noOfJoined = data.requisitionOpeningsCount ? data.requisitionOpeningsCount.noOfJoined : null;
        data.pocRecruiter = response.pocRecruiter ? response.pocRecruiter : null;
        data.recruitersCount = response.recruitersCount ? response.recruitersCount : null;
        data.primaryHiringManager = response.primaryHiringManager ? response.primaryHiringManager : null;
        response.data = data;
        return response;
    }

    private _getSalaryDetailsDisplayMessage(salary: any, salaryDurationOptions: any) {
        let message = "";
        if (_.isNull(salary.salaryType)) {
            message = message + "Not Available";
        } else if (salary.salaryType == "SPECIFIC") {
            message = message + salary.maxSalary + " " + salary.currency + " " + this._getUOM(salary.salaryDuration, salaryDurationOptions);
        } else if (salary.salaryType == "RANGE") {
            message = message + salary.minSalary + " to " + salary.maxSalary + " " + salary.currency + " " + this._getUOM(salary.salaryDuration, salaryDurationOptions);
        }
        return message;
    }

    private _getUOM(salaryDuration: any, salaryDurationOptions: any) {
        let uom: any = _.find(salaryDurationOptions, { value: salaryDuration });
        if (uom === undefined) {
            return "Per Month";
        }
        return uom.name;
    }

    private _removeReleasedAndUnInterestedSteps(workflowSteps: any[]) {
        workflowSteps.splice(workflowSteps.length - 2, 2);
    }

    //Requisition card actions
    performAction(action: any, requisitionInfo: any, refreshCardCallback: any) {
        let windowTopClass = '';
        let modalHeading = '';
        let formalizeActivityPayload: any = {
            candidate: null,
            requisition: new FormalizeRequisition(requisitionInfo.requisitionNumber, requisitionInfo.requisitionActualNumber, requisitionInfo.requisitionRole),
            jobMatch: new FormalizeJobMatch(requisitionInfo.jobMatchId, requisitionInfo.requisitionNumber, requisitionInfo.requisitionActualNumber, requisitionInfo.requisitionRole),
            company: new FormalizeCompany(requisitionInfo.companyId, requisitionInfo.companyName, requisitionInfo.clientOrBuId, requisitionInfo.clientName)
        };
        switch (action) {
            case 'jobProfile':
                modalHeading = 'Job Profile';
                windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
                break;
            case 'jobLeft':
                modalHeading = 'Job Left';
                windowTopClass = 'custom-modal-65 custom-candidate-job-match-modal';
                break;
            case 'doNotHire':
                modalHeading = 'Do Not Hire';
                windowTopClass = 'custom-modal-65 custom-candidate-job-match-modal';
                break;
            case 'clientReview':
                modalHeading = 'Client Review';
                windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
                break;
        }
        let modalData: any = {
            action: action,
            jobId: requisitionInfo.requisitionNumber,
            clientName: requisitionInfo.clientName,
            title: modalHeading,
            nonJoinedCandidates: requisitionInfo.nonJoinedCandidates,
            formalizeActivityPayload: formalizeActivityPayload,
            windowTopClass: windowTopClass
        };
        this.requisitionCardActionsModalService.show(modalData, refreshCardCallback);
    }

    performRequisitionAction(stateName: any, requisitionObject: any, companyId: any, copyCallback: any, deleteCallback: any, refreshCardCallback: any) {
        let requisitionSPOC: any = {};
        requisitionSPOC.time = '';
        requisitionSPOC.requisitionStatus = requisitionObject.requisitionStatus;
        requisitionSPOC.RequisitionId = requisitionObject.requisitionNumber;
        requisitionSPOC.Role = requisitionObject.requisitionRole;
        requisitionSPOC.noOfOpenings = requisitionObject.noOfOpenings;
        requisitionSPOC.noOfFilledOpenings = requisitionObject.noOfFilledOpenings;
        requisitionSPOC.noOfJustFilledOpenings = requisitionObject.noOfJustFilledOpenings;
        requisitionSPOC.Company = requisitionObject.companyName;
        this._setAndUpdateRequisitionSPOCDateTime(requisitionSPOC);
        requisitionSPOC.activeCandidateCount = requisitionObject.activeCandidateCount;
        requisitionSPOC.passiveCandidateCount = requisitionObject.passiveCandidateCount;
        requisitionSPOC.inertCandidateCount = requisitionObject.inertCandidateCount;
        requisitionSPOC.requisitionActualNumber = requisitionObject.requisitionActualNumber;

        let requisitionFlag = false;
        if (stateName === 'Make a Copy') {
            requisitionSPOC.titleName = stateName;
            requisitionSPOC.currentStateName = 'Copy';
        } else if ((requisitionObject.requisitionStatus === 'FILLED' || requisitionObject.requisitionStatus === 'Filled') && stateName === 'Stop Sourcing') {
            requisitionSPOC.titleName = 'Fill to Sourced';
            requisitionSPOC.currentStateName = stateName;
        } else if (stateName === 'Remove Filled Candidate') {
            requisitionSPOC.titleName = 'Remove Filled Candidate';
            requisitionSPOC.currentStateName = 'Stop Sourcing';
        } else if ((requisitionObject.requisitionStatus === 'COMPLETED' || requisitionObject.requisitionStatus === 'Completed') && stateName === 'Join') {
            requisitionSPOC.titleName = 'Completed to Joined';
            requisitionSPOC.currentStateName = stateName;
        } else if (stateName === 'Remove Joined Candidate') {
            requisitionSPOC.titleName = 'Remove Joined Candidate';
            requisitionSPOC.currentStateName = 'Fill';
        } else if (((requisitionObject.requisitionStatus || '').toLowerCase() === 'joined' || (requisitionObject.requisitionStatus || '').toLowerCase() === 'filled') && stateName === 'Remove Joined Candidate') {
            requisitionSPOC.titleName = 'Remove Joined Candidate';
            requisitionSPOC.currentStateName = 'Fill';
        } else if (requisitionObject.requisitionStatus === 'Canceled' && stateName === 'Continue') {
            requisitionFlag = true;
            requisitionSPOC.titleName = 'Reopen';
            requisitionSPOC.currentStateName = 'Reopen';
        }
        else if (requisitionObject.requisitionStatus === 'Sourced' && stateName === 'Continue') {
            requisitionSPOC.titleName = 'Resume Sourcing';
            requisitionSPOC.currentStateName = 'Resume Sourcing';
        } else {
            requisitionFlag = true;
            requisitionSPOC.currentStateName = stateName;
        }

        // set default notes
        if (stateName === 'Open') {
            requisitionSPOC.note = 'Opening Requisition';
        } else if (stateName === 'Stop Sourcing') {
            requisitionSPOC.note = 'Stop Sourcing the Requisition';
        } else if (stateName === 'Continue' && requisitionSPOC.currentStateName === 'Resume Sourcing') {
            requisitionSPOC.note = 'Resume Sourcing the Requistion';
        } else if (stateName === 'Continue') {
            requisitionSPOC.note = 'Continuing Requisition';
        } else if (stateName === 'Fill') {
            requisitionSPOC.note = 'Filling Candidate';
        } else if (stateName === 'Join') {
            requisitionSPOC.note = 'Joining Candidate';
        } else if (stateName === 'Make a Copy') {
            requisitionSPOC.note = 'Make a Copy';
        } else if (stateName === 'Delete') {
            requisitionSPOC.note = 'Deleting Requisition';
        }

        if (requisitionFlag) {
            this.genericService.getObjects(this.StorageService.get('baseurl') + 'api/job/getcandidatesforreqstatus/' + requisitionObject.requisitionNumber + '/' + stateName + '?companyId=' + companyId).subscribe((response: any) => {
                const data = response.body;
                let candidatesInLastStep: any[] = [];
                let candidates = _.cloneDeep(data.candidates);
                candidatesInLastStep = _.cloneDeep(data.candidatesInLastStepToFill);
                if (candidates.length === 0) {
                    candidates = [];
                }
                if (candidatesInLastStep.length === 0) {
                    candidatesInLastStep = [];
                }
                requisitionSPOC.requisitionOpeningNumber = data.requisitionOpeningNumber;
                if (stateName === 'Fill' && candidatesInLastStep.length === 0) {
                    this._showAlert('No candidates are available to Fill.');
                } else if (stateName === 'Join' && candidates.length === 0) {
                    this._showAlert('No candidates are available to Join.');
                } else {
                    if (candidates !== null && candidates.length > 0) {
                        for (let i = 0; i < candidates.length; i++) {
                            if (candidates[i].lastName !== null) {
                                candidates[i].name = candidates[i].firstName + ' ' + candidates[i].lastName;
                            } else {
                                candidates[i].name = candidates[i].firstName;
                            }
                        }
                    }
                    if (candidatesInLastStep !== null && candidatesInLastStep.length > 0) {
                        for (let i = 0; i < candidatesInLastStep.length; i++) {
                            if (candidatesInLastStep[i].lastName !== null) {
                                candidatesInLastStep[i].name = candidatesInLastStep[i].firstName + ' ' + candidatesInLastStep[i].lastName;
                            } else {
                                candidatesInLastStep[i].name = candidatesInLastStep[i].firstName;
                            }
                        }
                    }

                    this._massageJobMatchDetails(candidates, candidatesInLastStep);
                    this._showActionModal(requisitionSPOC, requisitionObject, candidates, candidatesInLastStep, copyCallback, deleteCallback, refreshCardCallback);

                }
            }, (error: any) => {
                // matches legacy behavior: swallow the error, no candidates available
            });
        } else if (stateName === 'Make a Copy') {
            this._showActionModal(requisitionSPOC, requisitionObject, [], [], copyCallback, deleteCallback, refreshCardCallback);
        } else {
            this.genericService.getObjects(this.StorageService.get('baseurl') + 'api/job/getcandidatesforcurrentstatus/' + requisitionObject.requisitionNumber + '/' + requisitionSPOC.currentStateName + '?companyId=' + companyId).subscribe((response: any) => {
                let candidates = response.body;
                if (candidates !== null && candidates.length > 0) {
                    for (let i = 0; i < candidates.length; i++) {
                        if (requisitionSPOC.currentStateName === 'Stop Sourcing') {
                            if (candidates[i].fillCandidate.contact.lastname !== null) {
                                candidates[i].name = candidates[i].fillCandidate.contact.firstname + ' ' + candidates[i].fillCandidate.contact.lastname;
                            } else {
                                candidates[i].name = candidates[i].fillCandidate.contact.firstname;
                            }
                        } else if (requisitionSPOC.currentStateName === 'Fill') {
                            if (candidates[i].joinCandidate.contact.lastname !== null) {
                                candidates[i].name = candidates[i].joinCandidate.contact.firstname + ' ' + candidates[i].joinCandidate.contact.lastname;
                            } else {
                                candidates[i].name = candidates[i].joinCandidate.contact.firstname;
                            }
                        }

                    }
                }

                if ((requisitionObject.requisitionStatus || '').toLowerCase() === 'filled' && stateName === 'Stop Sourcing' && candidates.length === 0) {
                    this._showAlert('No candidates are available in Filled state to remove');
                } else if ((requisitionObject.requisitionStatus || '').toLowerCase() === 'sourced' && stateName === 'Remove Filled Candidate' && candidates.length === 0) {
                    this._showAlert('No candidates are available in Filled state to remove');
                } else if (((requisitionObject.requisitionStatus || '').toLowerCase() === 'completed' || (requisitionObject.requisitionStatus || '').toLowerCase() === 'joined') && stateName === 'Fill' && candidates.length === 0) {
                    this._showAlert('No candidates are available in Joined state to remove');
                } else if ((requisitionObject.requisitionStatus || '').toLowerCase() === 'filled' && stateName === 'Remove Joined Candidate' && candidates.length === 0) {
                    this._showAlert('No candidates are available in Joined state to remove');
                } else if (requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                    let stepName = requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE ? 'REMOVE_FILL' : 'REMOVE_JOIN';
                    let steps = [stepName];
                    this.jobMatchService.getReasonCodes(steps, (data: any) => {
                        let stepKey = stepName === 'REMOVE_FILL' ? 'Remove Fill' : 'Remove Join';
                        this.reasonCodes = data[stepKey];
                        this.showBackwardActionModal(requisitionObject, requisitionSPOC, candidates, refreshCardCallback);
                    }, (error: any) => {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                } else {
                    this.showBackwardActionModal(requisitionObject, requisitionSPOC, candidates, refreshCardCallback);
                }
            }, (error: any) => {
                // matches legacy behavior: swallow the error, no candidates available
            });
        }
    }

    private _setAndUpdateRequisitionSPOCDateTime(requisitionSPOC: any) {
        requisitionSPOC.date = moment().format('ll');
        requisitionSPOC.time = moment().format('hh:mm:ss a');
        setTimeout(() => {
            this._setAndUpdateRequisitionSPOCDateTime(requisitionSPOC);
        }, 1000);
    }

    private _showAlert(message: any) {
        bootbox.alert({
            closeButton: false,
            title: '<div class="alert alert-danger" ><i class="fa fa-times-circle fa-fw fa-lg"></i><strong>Oh snap!</strong></div>',
            message: message
        });
    }

    private _massageJobMatchDetails(candidates: any[], candidatesInLastStep: any[]) {
        candidates.forEach(candidate => {
            candidate.candidateOtherJobMatchDetail.forEach((jobMatch: any) => {
                let i = 0;
                let recruitersMessage = '';
                jobMatch.recruiterNames.forEach((name: any) => {
                    if (i === jobMatch.recruiterNames.length - 1) {
                        recruitersMessage = `${recruitersMessage} ${name}`;
                    } else if (i === jobMatch.recruiterNames.length - 2) {
                        recruitersMessage = `${recruitersMessage} ${name} and `;
                    } else {
                        recruitersMessage = `${recruitersMessage} ${name}, `;
                    }
                    i++;
                });
                jobMatch.recruitersMessage = recruitersMessage;
            });
        });

        candidatesInLastStep.forEach(candidate => {
            if (candidate.candidateOtherJobMatchDetail !== null) {
                candidate.candidateOtherJobMatchDetail.forEach((jobMatch: any) => {
                    let i = 0;
                    let recruitersMessage = '';
                    jobMatch.recruiterNames.forEach((name: any) => {
                        if (i === jobMatch.recruiterNames.length - 1) {
                            recruitersMessage = `${recruitersMessage} ${name}`;
                        } else if (i === jobMatch.recruiterNames.length - 2) {
                            recruitersMessage = `${recruitersMessage} ${name} and `;
                        } else {
                            recruitersMessage = `${recruitersMessage} ${name}, `;
                        }
                        i++;
                    });
                    jobMatch.recruitersMessage = recruitersMessage;
                });
            }
        });
    }

    private _showActionModal(requisitionSPOC: any, requisitionInfo: any, candidates: any[], candidatesInLastStep: any[], copyCallback: any, deleteCallback: any, refreshCardCallback: any) {
        let vm = this;
        let modalData: any = {
            requisitionSPOC: requisitionSPOC,
            candidates: candidates,
            candidatesInLastStep: candidatesInLastStep,
            isSharedRequisition: requisitionInfo.sharedRequisition,
            formalizeActivityPayload: requisitionInfo.formalizeActivityPayload,
            modifyRequisitionStates: (req: any, direction: any) => {
                vm._modifyRequisitionStates(req, direction, refreshCardCallback);
            },
            copyRequisition: (req: any, doneCallback: any) => {
                vm.copyRequisition(req, () => {
                    doneCallback();
                    if (copyCallback) {
                        copyCallback(req);
                    }
                });
            },
            deleteRequisition: (req: any, doneCallback: any) => {
                vm.deleteRequisition(req, () => {
                    if (deleteCallback) {
                        deleteCallback();
                    }
                    doneCallback();
                });
            }
        };
        this.requisitionActionModalService.show(modalData);
    }

    private _modifyRequisitionStates(requisitionSPOC: any, direction: any, refreshCardCallback: any) {
        //Construct update status object
        let updateRequisitionObject: any = {};
        updateRequisitionObject.jobId = requisitionSPOC.RequisitionId;
        updateRequisitionObject.companyId = this.authService.getUserDetails().company.companyId;
        if (requisitionSPOC.currentStateName === 'Stop Sourcing') {
            updateRequisitionObject.jobStateType = 'SOURCED';
        } else if (requisitionSPOC.currentStateName === 'Fill') {
            updateRequisitionObject.jobStateType = 'FILLED';
            updateRequisitionObject.fillDate = requisitionSPOC.candidateFillDate;
            updateRequisitionObject.expectedJoinDate = requisitionSPOC.candidateExpectedJoinDate;
        } else if (requisitionSPOC.currentStateName === 'Complete') {
            updateRequisitionObject.jobStateType = 'COMPLETED';
        } else if (requisitionSPOC.currentStateName === 'Cancel') {
            updateRequisitionObject.jobStateType = 'CANCELED';
        } else if (requisitionSPOC.currentStateName === 'Continue' || requisitionSPOC.currentStateName === 'Reopen' || requisitionSPOC.currentStateName === 'Resume Sourcing') {
            updateRequisitionObject.jobStateType = 'OPEN';
        } else if (requisitionSPOC.currentStateName === 'Pause') {
            updateRequisitionObject.jobStateType = 'PAUSED';
        } else if (requisitionSPOC.currentStateName === 'Delete') {
            updateRequisitionObject.jobStateType = 'ARCHIVED';
        } else if (requisitionSPOC.currentStateName === 'Join') {
            updateRequisitionObject.jobStateType = 'JOINED';
            updateRequisitionObject.joinDate = requisitionSPOC.candidateJoinDate;
        } else {
            updateRequisitionObject.jobStateType = (requisitionSPOC.requisitionStatus || '').toUpperCase();
        }
        updateRequisitionObject.note = requisitionSPOC.note;
        updateRequisitionObject.externalNote = requisitionSPOC.externalNote;
        updateRequisitionObject.reasonCodeDTO = requisitionSPOC.reasonCodeDTO === undefined ? null : requisitionSPOC.reasonCodeDTO;
        updateRequisitionObject.updationDate = requisitionSPOC.date;
        updateRequisitionObject.updationTime = requisitionSPOC.time;
        updateRequisitionObject.requisitionActualNumber = requisitionSPOC.requisitionActualNumber;
        if (requisitionSPOC.candidate !== undefined) {
            if (requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE) {
                updateRequisitionObject.candidateId = requisitionSPOC.candidate.fillCandidate.id;
            } else if (requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                updateRequisitionObject.candidateId = requisitionSPOC.candidate.joinCandidate.id;
            } else {
                updateRequisitionObject.candidateId = requisitionSPOC.candidate.id;
            }
        }
        updateRequisitionObject.direction = direction;
        updateRequisitionObject.recruiterId = this.authService.getUserDetails().id;
        if (direction === 'Forward') {
            updateRequisitionObject.requisitionOpeningNumber = requisitionSPOC.requisitionOpeningNumber;
        } else if (direction === 'Backward' && requisitionSPOC.candidate !== undefined) {
            updateRequisitionObject.requisitionOpeningNumber = requisitionSPOC.candidate.requisitionOpeningNumber;
        }

        //Call the API to update the status
        if (updateRequisitionObject.jobStateType !== 'ARCHIVED') {
            this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.UPDATE_JOB_STATUS, updateRequisitionObject).subscribe((data: any) => {
                if (updateRequisitionObject.jobStateType === 'OPEN') {
                    if (requisitionSPOC.currentStateName === 'Reopen') {
                        updateRequisitionObject.jobStateType = 'reopened';
                    } else if (requisitionSPOC.currentStateName === 'Resume Sourcing') {
                        updateRequisitionObject.jobStateType = 'reopened for matching';
                    } else {
                        updateRequisitionObject.jobStateType = 'opened';
                    }
                } else if (requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                    updateRequisitionObject.jobStateType = 'updated';
                }
                if (requisitionSPOC.currentStateName === 'Reopen'
                    || requisitionSPOC.currentStateName === 'Cancel'
                    || requisitionSPOC.currentStateName === 'Complete') {
                    const title = requisitionSPOC.currentStateName + ' in progress.';
                    const message = `${requisitionSPOC.currentStateName} is in progress. You will be notified once the requisition is ${(updateRequisitionObject.jobStateType || '').toLowerCase()}.`;
                    this.alertsAndNotificationsService.showAlert(title, message, 'success');
                } else {
                    let successMessage = "Requisition '<b><i class='wrap-word'>(" + requisitionSPOC.requisitionActualNumber + ")</i></b>' " + (updateRequisitionObject.jobStateType || '').toLowerCase() + ' successfully.';
                    this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                }
                if (refreshCardCallback) {
                    refreshCardCallback();
                }

            }, (error: any) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }

    copyRequisition(requisition: any, copyCallback: any) {
        let requisitionObject = { id: requisition.RequisitionId, note: requisition.note };
        this.jobService.copyRequisition(requisitionObject.id, this.authService.getUserDetails().company.companyId, (data: any) => {
            this.alertsAndNotificationsService.showBannerMessage('Requisition Copy Created Successfully', 'success');
            if (copyCallback) {
                copyCallback(data);
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    deleteRequisition(requisition: any, deleteCallback: any) {
        let requisitionObject = { id: requisition.RequisitionId, note: requisition.note };
        this.jobService.deleteJob(requisitionObject, (data: any) => {
            this.alertsAndNotificationsService.showBannerMessage("Requisition '" + requisition.requisitionActualNumber + "' deleted successfully", 'success');
            if (deleteCallback) {
                deleteCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    showBackwardActionModal(requisitionInfo: any, requisitionSPOC: any, candidates: any[], refreshCardCallback: any) {
        let vm = this;
        let modalData: any = {
            requisitionSPOC: requisitionSPOC,
            candidates: candidates,
            isSharedRequisition: requisitionInfo.sharedRequisition,
            reasonCodes: vm.reasonCodes,
            formalizeActivityPayload: requisitionInfo.formalizeActivityPayload,
            modifyRequisitionStates: (req: any, direction: any) => {
                vm._modifyRequisitionStates(req, direction, refreshCardCallback);
            },
            showAlert: (title: any, message: any) => {
                vm.alertsAndNotificationsService.showAlert(title, message, 'warning');
            }
        };
        this.requisitionBackwardActionModalService.show(modalData);
    }

    showAllActivities(requisitionInfo: any) {
        let modalData = {
            jobId: requisitionInfo.requisitionNumber,
            role: requisitionInfo.requisitionRole,
            requisitionNumber: requisitionInfo.requisitionActualNumber,
            clientName: requisitionInfo.companyName,
            isSharedRequisition: requisitionInfo.sharedRequisition
        };
        this.requisitionActivityModalService.show(modalData);
    }
}
